export enum PointsInfoBannerType {
	JOIN_BASIC_AND_PLUS = 'JoinBasicAndPlus',
	PLUS = 'Plus',
	BASIC = 'Basic',
	NO_CONTENT = 'NoContent',
	TO_LOGIN = 'ToLogin'
}
